import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

import projectad from '../Images/project-ad.jpg';
import projectbl from '../Images/project-bl.jpg';
import projecticw from '../Images/icw-project.jpg';
import cooper from '../Images/cooper-image.jpg';
import laptop from '../Images/laptop-myresource.jpg'
import projectcomm from '../Images/communitee-project.jpg';
import empty from '../Images/empty.jpg';
import projectbizgainz from '../Images/bizgainz-project.jpg';

class Portfolio extends Component {
  
    constructor(props) {
        super();
        this.props = props;
        this.state = {
          Tab1ClassName: "tab-container-selected",
          Tab2ClassName: "tab-container",
          Tab3ClassName: "tab-container",
          Tab4ClassName: "tab-container",

          Tab1Icon1ClassName: "tab-icon-hidden",
          Tab1Icon2ClassName: "tab-icon-visible",
          Tab2Icon1ClassName: "tab-icon-visible",
          Tab2Icon2ClassName: "tab-icon-hidden",
          Tab3Icon1ClassName: "tab-icon-visible",
          Tab3Icon2ClassName: "tab-icon-hidden",
          Tab4Icon1ClassName: "tab-icon-visible",
          Tab4Icon2ClassName: "tab-icon-hidden",

          AllWorkProjectsStyle: "block",
          GamDevProjectsStyle: "none",
          UXDesignProjectsStyle: "none",
          WebDevProjectsStyle: "none",

          tab1ContainerStyle: {},
          tab2ContainerStyle: {},
          tab3ContainerStyle: {},
          tab4ContainerStyle: {}


        }
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);

    // while (true) {
    //   this.setState({Tab1ClassName: "tab-container-selected"});

    // }
  }

  

  componentWillUnmount(){

  }

  rerouteTo(URL) {
    // const navigate = useNavigate();
    // navigate('/home')
  }  

  render () {

    return (
        
      <div id="home">

          <div className="home-me-container">
            <div className="general-text-container">
              <p className="project-text-medium">My work</p>
              <p className="project-paragraph">View my past projects that cover my UX design, software development, and product design experience.</p>
            </div>
          </div>

          <div class="projects-container">
            <p className="project-text-small">Featured</p>
            <div className="projects-container-column">
              <div className="projects-container-row">
                

                <Link to="/portals" class="link"><div className="project">
                  <img className="project-image-rounded" src={laptop} alt=""></img>
                  <p className="project-title">Insurance Company Portals</p>
                  <p className="project-subtext">UI design and dev of 2 customer portals</p>
                </div></Link>

                <Link to="/bajookieland" class="link"><div className="project">
                  <img className="project-image-rounded" src={projectbl} alt=""></img>
                  <p className="project-title">Bajookieland Game</p>
                  <p className="project-subtext">iOS app developed in Unity</p>
                </div></Link>

                <Link to="/bizgainz" class="link"><div className="project">
                  <img className="project-image-rounded" src={projectbizgainz} alt=""></img>
                  <p className="project-title">BizGainz E-Commerce Platform</p>
                  <p className="project-subtext">E-Commerce Web Services</p>
                </div></Link>
              </div>
            </div>
            <p className="project-text-small" style={{paddingTop:"48px"}}>More Projects</p>
            <div className="projects-container-column">
              <div className="projects-container-row">
                <Link to="/communitee" class="link"><div className="project">
                  <img className="project-image-rounded" src={projectcomm} alt=""></img>
                  <p className="project-title">Communitee.io</p>
                  <p className="project-subtext">Messaging platform & e-commerce shop</p>
                </div></Link>
                
                <Link to="/redesign" class="link"><div className="project">
                  <img className="project-image-rounded" src={projecticw} alt=""></img>
                  <p className="project-title">Website Redesign</p>
                  <p className="project-subtext">Full UX lifecycle for corporate website</p>
                  </div></Link>


                

                <Link to="/additive-drinking" class="link"><div className="project">
                  <img className="project-image-rounded" src={projectad} alt=""></img>
                  <p className="project-title">Additive Drinking</p>
                  <p className="project-subtext">Card game, e-commerce site, and Kickstarter</p>
                </div></Link>
              </div>
              <div className="projects-container-row">
                <Link to="/cooperhead-art" class="link"><div className="project">
                    <img className="project-image-rounded" src={cooper} alt=""></img>
                    <p className="project-title">Cooperhead Art Website</p>
                    <p className="project-subtext">Website design and dev for a painter</p>
                </div></Link>
                <div className="project" style={{opacity: "0", pointerEvents: "none"}}>
                    <img className="project-image-rounded" src={empty} alt=""></img>
                </div>
                <div className="project" style={{opacity: "0", pointerEvents: "none"}}>
                    <img className="project-image-rounded" src={empty} alt=""></img>
                </div>
              </div>
            </div>
          </div>

      </div>
    );
  }
}

export default Portfolio;
